// Module
var code = `<form-section form-title="\$ctrl.incomeFormTitle">
  <form-section-field field-title="'Monthly income amount (Estimate)'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'annual_income')">
    <cash required
          ng-model="\$ctrl.monthlyIncome"
          ng-disabled="!\$ctrl.editMode"></cash>
  </form-section-field>
  <form-section-field field-title="'Annual income amount (Estimate)'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'annual_income')">
    <cash required
          ng-model="\$ctrl.sourceOfIncome.annualIncome"
          ng-disabled="!\$ctrl.editMode"></cash>
  </form-section-field>

  <form-section-field field-title="'Income source'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'source')">
    <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'source')"
            disabled="true"
            type="text"
            ng-model="\$ctrl.sourceOfIncome.type"
            ng-options="entry.code as entry.description for entry in \$ctrl.types">
      <option></option>
    </select>
  </form-section-field>

  <form-section-field field-title="'Primary'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'primary')">
    <select ng-model="\$ctrl.sourceOfIncome.primary"
            ng-class="{'non-valid-primary-income-source': !\$ctrl.hasOnePrimaryIncomeSource()}"
            ng-disabled="!\$ctrl.editMode"
            ng-change="\$ctrl.primaryIncomeSourceChanged(\$ctrl.sourceOfIncome, \$index)"
            boolean-options>
    </select>
  </form-section-field>

  <form-section-field field-title="'Nature of work/business'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'nature_of_work')">
    <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'nature_of_work')"
            ng-model="\$ctrl.sourceOfIncome.natureOfWorkId"
            ng-change="\$ctrl.refreshNatureOfWorkFields()"
            ng-disabled="!\$ctrl.editMode"
            ng-options="entry.id as entry.description for entry in \$ctrl.natureOfWorkOptions | orderBy:'id'">
    </select>
  </form-section-field>

  <form-section-field field-title="'Nature type'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'nature_type') && (\$ctrl.sourceOfIncome.natureTypeId || \$ctrl.natureTypeOptions.length > 0)">
    <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'nature_type')"
            ng-model="\$ctrl.sourceOfIncome.natureTypeId"
            ng-change="\$ctrl.refreshNatureOfWorkFields()"
            ng-disabled="!\$ctrl.editMode"
            ng-options="entry.id as entry.description for entry in \$ctrl.natureTypeOptions | orderBy:'id'">
    </select>
  </form-section-field>

  <form-section-field field-title="'Business type'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'business_type') && (\$ctrl.sourceOfIncome.businessTypeId || \$ctrl.businessTypeOptions.length > 0)">
    <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'business_type')"
            ng-model="\$ctrl.sourceOfIncome.businessTypeId"
            ng-change="\$ctrl.refreshNatureOfWorkFields()"
            ng-disabled="!\$ctrl.editMode"
            ng-options="entry.id as entry.description for entry in \$ctrl.businessTypeOptions | orderBy:'id'">
    </select>
  </form-section-field>

  <form-section-field field-title="'Description'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'description') && (\$ctrl.showRemarks || \$ctrl.cfg.required(\$ctrl.module, 'income', 'description'))">
    <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'description')"
           ng-model="\$ctrl.sourceOfIncome.description"
           ng-disabled="!\$ctrl.editMode"
           type="text"
           placeholder="Description"
           maxlength="255">
  </form-section-field>

  <form-section-field field-title="'PSIC/Industry equivalent'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'psicId')">
    <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'psicId')"
            ng-model="\$ctrl.sourceOfIncome.psicId"
            ng-disabled="!\$ctrl.editMode || \$ctrl.psicAutoSelect"
            ng-options="entry.id as entry.description for entry in \$ctrl.dict.PSIC_INDUSTRY_CLASSIFICATION | orderBy:'id'">
        <option></option>
    </select>
  </form-section-field>

  <form-section-field field-title="'Workplace characteristics'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'workplace_characteristics')">
    <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'workplace_characteristics')"
            ng-model="\$ctrl.sourceOfIncome.workplaceCharacteristicsId"
            ng-disabled="!\$ctrl.editMode"
            ng-options="entry.id as entry.description for entry in \$ctrl.dict.WORKPLACE_CHARACTERISTICS | orderBy:'id'">
    </select>
  </form-section-field>
</form-section>

<form-section form-title="\$ctrl.employmentFormTitle" ng-if="\$ctrl.sourceOfIncome.type == 'SALARY'">
  <form-section-field field-title="'Employer name'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'employer_name')">
    <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'employer_name')"
           ng-model="\$ctrl.sourceOfIncome.employerName"
           ng-disabled="!\$ctrl.editMode"
           type="text"
           placeholder="Employer name"
           maxlength="64"/>
  </form-section-field>

  <form-section-field field-title="'Employer branch'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'employer_branch')">
    <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'employer_branch')"
           ng-model="\$ctrl.sourceOfIncome.employerBranch"
           ng-disabled="!\$ctrl.editMode"
           type="text"
           placeholder="Employer branch"
           maxlength="64"/>
  </form-section-field>

  <form-section-field field-title="'Employer type'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'employer_type')">
    <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'employer_type')"
            ng-model="\$ctrl.sourceOfIncome.employerType"
            ng-disabled="!\$ctrl.editMode"
            ng-options="employerType | prettyEnum for employerType in \$ctrl.employerTypes">
      <option></option>
    </select>
  </form-section-field>

  <form-section-field field-title="'Employment start date'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'employment_start_date')">
    <date type="month"
          ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'employment_start_date')"
          ng-model="\$ctrl.sourceOfIncome.employmentStartDate"
          init-with-null="true"
          ng-disabled="!\$ctrl.editMode"
          placeholder="Employment start date"
          validate-date="lte:posting-date">
  </form-section-field>

  <form-section-field field-title="'Landline number'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'landline_number')">
    <telephone ng-model="\$ctrl.sourceOfIncome.landlineNumber"
               ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'landline_number')"
               ng-disabled="!\$ctrl.editMode"></telephone>
  </form-section-field>
  <form-section-field field-title="'Mobile number'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'mobile_number')">
    <telephone ng-model="\$ctrl.sourceOfIncome.mobileNumber"
               ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'mobile_number')"
               ng-disabled="!\$ctrl.editMode"></telephone>
  </form-section-field>
  <address ng-model='\$ctrl.sourceOfIncome.companyAddress' edit-mode="\$ctrl.editMode" module="\$ctrl.module" section="'income'"></address>

</form-section>

<form-section form-title="\$ctrl.companyFormTitle" ng-if="\$ctrl.sourceOfIncome.type != 'SALARY'">
  <form-section-field field-title="'Business name'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'company_name')">
    <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'company_name')"
           ng-model="\$ctrl.sourceOfIncome.companyName"
           ng-disabled="!\$ctrl.editMode"
           type="text"
           placeholder="Business name"
           maxlength="64">
  </form-section-field>
  <form-section-field field-title="'Business TIN'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'business_tin')">
    <input
      ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'business_tin')"
      ng-disabled="!\$ctrl.editMode"
      type="text"
      ui-mask="999-999-999-999"
      ui-mask-placeholder
      ui-options="{clearOnBlur: false}"
      ng-model="\$ctrl.sourceOfIncome.businessTin"
      ng-minlength="1"
      ng-maxlength="20"/>
  </form-section-field>
  <form-section-field field-title="'No. of paid employees'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'no_of_paid_employees')">
    <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'no_of_paid_employees')"
           ng-model="\$ctrl.sourceOfIncome.noOfPaidEmployees"
           ng-disabled="!\$ctrl.editMode"
           type="number"
           placeholder="No. of paid employees"
           min="0"
           max="10000000">
  </form-section-field>
  <form-section-field field-title="'Business start date'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'business_start_date')">
    <date type="month"
          ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'business_start_date')"
          ng-model="\$ctrl.sourceOfIncome.businessStartDate"
          init-with-null="true"
          ng-disabled="!\$ctrl.editMode"
          placeholder="Business start date"
          validate-date="lte:posting-date">
  </form-section-field>
  <form-section-field field-title="'Business structure'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'business_structure')">
    <select ng-options="o | prettyEnum for o in \$ctrl.businessStructureOptions"
            ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'business_structure')"
            ng-disabled="!\$ctrl.editMode"
            ng-model="\$ctrl.sourceOfIncome.businessStructure">
    </select>
  </form-section-field>
  <form-section-field field-title="'Business total assets'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'company_total_assets')">
    <cash ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'company_total_assets')"
          ng-model="\$ctrl.sourceOfIncome.companyTotalAssets"
          ng-disabled="!\$ctrl.editMode"></cash>
  </form-section-field>
  <form-section-field field-title="'Landline number'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'landline_number')">
    <telephone ng-model="\$ctrl.sourceOfIncome.landlineNumber"
               ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'landline_number')"
               ng-disabled="!\$ctrl.editMode"></telephone>
  </form-section-field>
  <form-section-field field-title="'Mobile number'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'mobile_number')">
    <telephone ng-model="\$ctrl.sourceOfIncome.mobileNumber"
               ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'mobile_number')"
               ng-disabled="!\$ctrl.editMode"></telephone>
  </form-section-field>
  <form-section-field field-title="'Principal Place of Operations'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'principal_place_of_operations')">
    <input
      type="text"
      ng-model="\$ctrl.sourceOfIncome.principalPlaceOfOperations"
      ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'principal_place_of_operations')"
      ng-disabled="!\$ctrl.editMode"
      maxlength="1024"/>
  </form-section-field>
  <address ng-model='\$ctrl.sourceOfIncome.companyAddress' edit-mode="\$ctrl.editMode" module="\$ctrl.module" section="'income'"></address>

  <form-section-field field-title="'Business Address Ownership'" ng-if="\$ctrl.sourceOfIncome.type == 'BUSINESS'">
    <select ng-model="\$ctrl.sourceOfIncome.businessAddressOwnershipType"
            ng-disabled="!\$ctrl.editMode"
            ng-options="ownershipType | prettyEnum for ownershipType in \$ctrl.ownershipTypes">
    </select>
  </form-section-field>
</form-section>
<form-section form-title="\$ctrl.performanceFormTitle" ng-if="\$ctrl.sourceOfIncome.type != 'SALARY'">
  <form-section-field field-title="'Number of Branches'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'no_of_branches')">
    <input type="number"
           min="0"
           max="999999"
           ng-model="\$ctrl.sourceOfIncome.noOfBranches"
           ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'no_of_branches')"
           ng-disabled="!\$ctrl.editMode"/>
  </form-section-field>
  <form-section-field field-title="'Avg. Daily Sales'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'avg_daily_sales')">
    <cash ng-model="\$ctrl.sourceOfIncome.avgDailySales"
          ng-disabled="!\$ctrl.editMode"
          ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'avg_daily_sales')">
    </cash>
  </form-section-field>
  <form-section-field field-title="'Avg. Monthly Sales'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'avg_monthly_sales')">
    <cash ng-model="\$ctrl.sourceOfIncome.avgMonthlySales"
          ng-disabled="!\$ctrl.editMode"
          ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'avg_monthly_sales')">
    </cash>
  </form-section-field>
  <form-section-field field-title="'Avg. Monthly Expenses'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'avg_monthly_expenses')">
    <cash ng-model="\$ctrl.sourceOfIncome.avgMonthlyExpenses"
          ng-disabled="!\$ctrl.editMode"
          ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'avg_monthly_expenses')">
    </cash>
  </form-section-field>
</form-section>
<div ng-show="\$ctrl.editMode" ng-if="\$ctrl.module !== 'agent' || !\$ctrl.sourceOfIncome.id">
  <button ng-click="\$ctrl.removeIncomeSource(\$ctrl.sourceOfIncome)"
          class="btn btn-danger btn--align-with-form-field" type="button">
    Remove source of income
  </button>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/income-source/common-income-source.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;